import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { DASHBOARD, FORGOT_PASSWORD } from "../utils/RouteConstant";
import AuthLayout from "../customComponent/AuthLayout";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/action/Auth/AuthAction";
import { GetProfileDetails } from "../../redux/action/Profile/AdminProfileAction";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { TextField } from "@mui/material";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    error: authError,
    token,
  } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      navigate(DASHBOARD);
    }
  }, [token, navigate]);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required."),
    password: Yup.string().required("Password is required."),
  });

  const handleLogin = async (values, { setErrors }) => {
    const { email, password } = values;

    try {
      await dispatch(login(email, password));
      // await dispatch(GetProfileDetails());
    } catch (error) {
      if (authError) {
        if (authError.includes("incorrect email")) {
          setErrors({ email: "Incorrect email." });
        } else if (authError.includes("incorrect password")) {
          setErrors({ password: "Incorrect password." });
        } else {
          setErrors({
            email: "Incorrect email.",
            password: "Incorrect password.",
          });
        }
      }
    }
  };

  const loginForm = (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={validationSchema}
      onSubmit={handleLogin}
    >
      {({ values, handleChange, handleSubmit, errors }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="email">
            {({ field }) => (
              <TextField
                {...field}
                label="Email"
                fullWidth
                error={!!errors.email}
                helperText={<ErrorMessage name="email" />}
              />
            )}
          </Field>

          <div className="relative mt-4 mb-4">
            <Field name="password">
              {({ field }) => (
                <TextField
                  {...field}
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  error={!!errors.password}
                  helperText={<ErrorMessage name="password" />}
                />
              )}
            </Field>
            <button
              type="button"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEye size={24} /> : <IoMdEyeOff size={28} />}
            </button>
          </div>

          {authError === "Incorrect email and password" && (
            <p className="text-red-500">
              Invalid Credentials. Please try again.
            </p>
          )}

          <div className="flex items-center justify-between">
            <label className="flex items-center text-sm text-gray-600">
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                checked={values.rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              <span className="ml-2">Remember me</span>
            </label>
            <Link
              to={FORGOT_PASSWORD}
              className="text-sm text-red-500 hover:underline"
            >
              Forgot Password?
            </Link>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full text-center sm:w-auto mt-4 lg:w-full xl:w-full bg-blue-900 text-white p-2 rounded-md"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </Form>
      )}
    </Formik>
  );

  return (
    <AuthLayout
      title="Login"
      description="Login to access your account"
      form={loginForm}
    />
  );
};

export default Login;
